export enum FeatureToggleType {Persons = 1,
    Vehicles = 2,
    Incidents = 3,
    Charging = 4,
    DomesticViolence = 5,
    FieldContact = 6,
    AdvancedSearch = 7,
    UseOfForce = 8,
    DNA = 9,
    Locations = 10,
    Organizations = 11,
    Property = 12,
    ChargingDocument = 13,
    JuvenileAllegation = 14,
    SearchWarrant = 15,
    ActivityTracking = 16,
    IncidentReviews = 17,
    GlobalSearch = 18,
    UserAdministration = 19,
    SystemAdministration = 20,
    ConfigurableFields = 21,
    DigitalMedia = 22,
    Notifications = 23,
    NIBRS = 24,
    ChargingBooking = 25,
    ChargingParkingTicket = 26,
    ThirdPartyLocationAPI = 27,
    GoogleMapEmbedded = 28,
    UCR = 29,
    RestrictionManagement = 30,
    IRFAssignment = 31,
    PropertyBarcoding = 33,
    GoogleAddressValidation = 35,
    IncidentReportProfessionalStandards = 36,
    DashboardManagement = 37,
    CADEventHistory = 38,
    CodesMaintenance = 39,
    PropertyRoom = 40,
    DashboardWidgetsGeneral = 41,
    DashboardWidgetsAdvanced = 42,
    GroupManagement = 43,
    ParkingTicket = 44,
    AlarmBilling = 45,
    Clery = 46,
    BookingDetaineeProperty = 47,
    PropertyRelease = 48,
    LetterheadTemplate = 49,
    AOPCEfile = 50,
    AOPCOtn = 51,
    CPIN = 52,
    DetaineeSeparation = 53,
    BookingStatisticsReport = 54,
    FingerprintStatisticsReport = 55,
    BillOfCosts = 56,
    MagisterialDistrictCourtFieldReceipt = 57,
    BloodDrawCostSheet = 58,
    CentralBooking = 59,
    DetaineeTransfer = 60,
    Recombination = 61,
    TrafficStop = 62,
    CAD = 63,
    SystemMaintenance = 64,
    ChargingAppearanceTickets = 65,
    CodeConversion = 66,
    ChargingViolationStatistics = 67,
    AiQuickSearch = 68,
    OfficerAnalysisReport = 69,
    CourtOrders = 70,
    CallForService = 71,
    /**
     * The Pathfinder V2 stack: offline cache, offline-capable search, live reference-data updates and the
     * outbound command queue. Read through `PathfinderV2Gate`, never directly — the gate carries the
     * environment fallback that keeps developer and QA machines working while the row ships disabled.
     */
    PathfinderV2 = 72,
    ResponseAlert = 73,
    /**
     * Pathfinder's Offline Mode, per tenant: the background record cache and creating or editing records while
     * offline. Requires PathfinderV2. Read through `OfflinePolicyStore` (`@pathfinder/shared/data-access`), never
     * directly — a toggle list cached before this toggle existed does not contain it, and the store reads that
     * absence as "follow PathfinderV2" rather than as off.
     */
    OfflineMode = 74,
} 